import { COMPANY_DEFAULT_FLOOD_PRODUCT_OPTION } from './LoanActionFloodServiceRow.constants';

export const getFloodProductOverrideOptions = (floodProductOptions = []) => [
  COMPANY_DEFAULT_FLOOD_PRODUCT_OPTION,
  ...floodProductOptions,
];
